var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCashapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Cash App",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 115,
    fill: "#00D632"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M295.7 148.3c-9.8-8.6-23.4-13.9-38.8-15.6l3.9-19.1a9 9 0 0 0-8.8-10.8h-22.3a9 9 0 0 0-8.8 7.2l-3.6 17.7c-31.7 3.7-56.9 22.4-56.9 54.7 0 30.4 23.8 43.9 60.9 55.9 26.9 8.9 36.4 15.5 36.4 27.4 0 12.2-11.7 19.4-29 19.4-19.8 0-38.5-8.4-52.9-21.2a9 9 0 0 0-12.3.3l-16.1 15.6a9 9 0 0 0 .3 13.1c11.9 10.6 26.9 18.4 43.4 22.6l-3.8 18.7a9 9 0 0 0 8.8 10.8l22.4.1a9 9 0 0 0 8.8-7.2l3.6-17.9c37.9-2.4 61.4-23.9 61.4-56.9 0-30.1-24.9-42.8-62.1-55.5-21.3-7.6-35.4-12.8-35.4-25.9 0-12.7 13.9-17.7 27.9-17.7 18 0 35.4 7.6 47.5 18.2a9 9 0 0 0 12.2-.4l15.4-15.6a9 9 0 0 0-.3-13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCashapp);
export default __webpack_public_path__ + "static/media/ico_cashapp.7ba683e0d3f79d0a0f00bb10eb271040.svg";
export { ForwardRef as ReactComponent };